// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { InvitationModel } from '../../../models';
import { RespondentReminderBaseService } from './respondent-reminder-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class RespondentReminderMockService extends RespondentReminderBaseService {

  constructor() {
    super();
  }

  reminderRequest(model: InvitationModel): void {
    throw new Error('Method not implemented.');
  }
}
